export default {
  configurations: state => state.configurations,
  configurationById: state => id =>
    state.configurations
      ? state.configurations.find(configuration => configuration.id === id)
      : null,
  configurations_pending: state => state.configurations_pending
}
